import { ConfirmAuthorizationController } from './confirmAuthorization.controller';
import template from './confirmAuthorization.html';

export const confirmAuthorizationComponent = {
  name: 'confirmAuthorization',
  restrict: 'E',
  template,
  controller: ConfirmAuthorizationController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    submit: '&',
    reject: '&'
  }
};
